import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler } from 'Modules'
import { DrsNS, drsSlice, drsSelectors, drsApi, TYPE_DRS_CM_VISIT } from 'Pages/registratorCabinet'
import { RequestParams, ResponseCatalog } from 'Models'
import { unionBy } from 'lodash'
import { SberGeoUnitModel, sberGeoUnitApi } from 'Pages/orders_design'
import { regionApi } from 'Pages/referenceBooks'

export function* getDrsOfficeSaga(action: DrsNS.GetDrsOffice) {
	try {
		const city = action.payload.address?.city || action.payload.address?.region
		const addressRegionCode = action.payload.address?.regionCode
		// TODO: в задаче 11531 временно по умолчанию оставляем выбранным способ "В офисе банка"
		// let isManager = true
		// let resRegion = yield* call(
		// 	regionApi.getAll,
		// 	new RequestParams(1, 30, null, {
		// 		code: addressRegionCode,
		// 		used_in_sber_geo_units: true,
		// 		with_manager: isManager,
		// 	})
		// )
		// let regionId = resRegion?.entries?.[0]?.id
		// let resTown = yield* call(
		// 	sberGeoUnitApi.getAddresses,
		// 	new RequestParams(1, 30, null, {
		// 		sber_mq_region_id: regionId,
		// 		used_in_sber_geo_units: true,
		// 		with_manager: isManager,
		// 	})
		// )
		// let town = (resTown?.town_names || []).find((town) => town === city)
		// if (!town) {
		const isManager = false
		const resRegion = yield* call(
			regionApi.getAll,
			new RequestParams(1, 30, null, {
				code: addressRegionCode,
				used_in_sber_geo_units: true,
				with_manager: isManager,
			})
		)
		const regionId = resRegion?.entries?.[0]?.id
		const resTown = yield* call(
			sberGeoUnitApi.getAddresses,
			new RequestParams(1, 30, null, {
				sber_mq_region_id: regionId,
				used_in_sber_geo_units: true,
				with_manager: isManager,
			})
		)
		const town = (resTown?.town_names || []).find((town) => town === city)
		// }
		yield* put(
			drsSlice.actions.setOne({
				drs_cm_visit_flag: isManager ? TYPE_DRS_CM_VISIT.MANAGER : TYPE_DRS_CM_VISIT.OFFICE,
				sber_mq_region_id: regionId,
				town_name: town,
			})
		)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* getUnits(action?: DrsNS.getUnits) {
	try {
		const { params, options } = action.payload
		let paramsForRequest: RequestParams

		if (params) {
			paramsForRequest = params
		} else {
			paramsForRequest = yield* select(drsSelectors.getCurrentParams)
		}
		const res = yield* call(drsApi.getUnits, paramsForRequest)
		const items = new ResponseCatalog<SberGeoUnitModel>(res)
		if (options?.loadMore || options?.searchMissing) {
			const oldItems = yield* select(drsSelectors.getUnits)
			items.entries = options?.searchMissing
				? oldItems.entries.concat(items.entries)
				: unionBy(oldItems.entries, items.entries, 'id')
			if (options?.searchMissing) items.total_entries = oldItems.total_entries
		}
		yield* put(drsSlice.actions.setAllUnits(items))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
export function* drsSaga() {
	yield* takeLatest(drsSlice.actions.getOne.type, getDrsOfficeSaga)
	yield* takeLatest(drsSlice.actions.getAllUnits.type, getUnits)
}
